import React from "react";
import { EuiButtonEmpty } from "@elastic/eui";
import { useDispatch } from "react-redux";

/**
 * This component is setting local storage to null and redirect to login
 */

import { logout } from "../../../auth/slice";

function LogoutComponent() {
    const dispatch = useDispatch();

    return (
        <EuiButtonEmpty
            onClick={() => {
                dispatch(logout());
            }}
            iconType="exit"
        >
            Logout
        </EuiButtonEmpty>
    );
}

export default LogoutComponent;
